import { useEffect, useState } from "react";
import { ContractService } from "../../../../core/services/ContractService"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { Singleton } from '../../../../core/services/Singleton';
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { UBLInvoiceList } from "./ublinvoice/UBLInvoiceList";
import { UBLCONTRACT, UBLParam, UBLSUPPLIER } from "./ContracInterface";
import { PrintJson } from "../../../theme/Component/PrintJson";
import useModal, { MODAL_LG, MODAL_md } from "../../../theme/Component/hooks/useModal";
import { SupplierPaymentOrder } from "../../../Talentohumano/GestionTH/SupplierPaymentOrder/SupplierPaymentOrder";
import { AdquisitionContractRP } from "./adquisitionContractRP/AdquisitionContractRP";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _BusinessProcess, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { ContractFiles } from "../ContractFiles";
import { EditorExpedientDocumentFile } from "../../../DocumentManagement/Management/DocumentFileManager/EditorExpedientDocumentFile";



export const Contracts = () => {

    const _bProcess = useDataBean(_BusinessProcess)
    const contracService = new ContractService();



    const [obs, setObs] = useState<string>("");
    const [row, setRow] = useState<any>({});
    const [modalPC, setModalPC] = useState<any>({ name: 'Gestión de Ordenes de Pago', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Facturas', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalConf, setModalConf] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalCDP, setModalCDP] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalRP, setModalRP] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalExpe, setModalExpe] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    const modalRequest = useModal("", MODAL_md);
    const modalBuscar = useModal("Buscar Factura", MODAL_LG);
    const paginador = usePaginator();

    const [params, setParams] = useState<UBLParam>(
        {
            IDAccountSupplier: row.IDAccountSupplier,
            IDAdquisitionContract: row.IDAdquisitionContract,
            From: _single.getCurrenDate(),
            Upto: _single.getCurrenDate(),
            State: null
        }
    );

    useEffect(() => {

        getAdquisitionContractRender();

    }, [])
    useEffect(() => {
        getAdquisitionContractRender();
    }, [paginador.page])

    useEffect(() => {
        setParams({ ...params, "IDAccountSupplier": row.IDAccountSupplier, "IDAdquisitionContract": row.IDAdquisitionContract });

    }, [row])


    const getAdquisitionContractRender = () => {
        _single.spinner(true);
        contracService.getAdquisitionContractRenderByIDAccount(null, null, { State: 1 }, _single.getAccountID()).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                setModalConf({ ...modalConf, "view": false });
                _single.spinner(false);
            }
        )
    }


    const [lista, setLista] = useState<any>([]);

    const head = [
        { title: 'ID', property: 'IDAdquisitionContract', visible: false, mask: MASK_NUMBER },
        { title: 'Código contrato', property: 'InternalCode', visible: true },
        { title: 'Valor Contrato', property: 'ContractAmount', visible: true, mask: MASK_MONEY },
        { title: 'Modalidad', property: 'NameModality', visible: true },
        { title: 'Nit', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Proveedor', property: 'Name1', visible: true },
        { title: 'Fecha Contrato', property: 'SeleccionDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Final', property: 'FinalContractDate', visible: true, mask: MASK_DATE },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Estado', property: 'PreparationStateName', visible: true },
        { title: 'Radicado', property: 'Code', visible: false },
    ]

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Facturas contrato', icono: 'ri-file-zip-line', visible: true, evento: () => { setModal({ ...modal, "view": true }) } },
            // { titulo: 'Buscar facturas', icono: 'ri-file-search-fill', visible: true, evento: () => { modalBuscar.open() } },
            // { titulo: 'Gestión de Ordenes de Pago', icono: 'ri-file-zip-line', visible: true, evento: () => { setModalPC({ ...modalPC, "view": true }) } },
            { titulo: 'Expediente del Contrato', icono: 'ri-folder-5-line', visible: true, evento: () => { setModalExpe({ ...modalExpe, "view": true, "name": "Documenos Contrato" }) } },
            // { titulo: 'CDP Asociados', icono: 'ri-file-list-line', visible: true, evento: () => { setModalCDP({ ...modalCDP, "view": true, "name": "CDP Asociados" }) } },
            { titulo: 'RP Asociados', icono: 'ri-file-list-line', visible: true, evento: () => { setModalRP({ ...modalRP, "view": true, "name": "RP Asociados" }) } },
            {
                titulo: 'Solicitar Orden de Pago', icono: 'ri-check-line', visible: true, evento: () => {
                    setSelectedAction("STARTSOLOP");
                    modalRequest.open("Iniciar Solicitud de Orden de Pago");
                }
            },
            {
                titulo: 'Solicitud liquidacion de Contrato', icono: 'ri-money-dollar-box-line', visible: row.PreparationState == 12, evento: () => {
                    setSelectedAction("GCLC");
                    modalRequest.open(`Solicitar liquidacion de contato  ${row.InternalCode ?? row.IDAdquisitionContract}`);
                }
            },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [selectedAction, setSelectedAction] = useState<string>("");
    const [isValid, setIsValid] = useState<boolean>(false);

    const handleModalSubmit = () => {
        if (!obs || obs.length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
            setIsValid(true);
            return;
        }

        setIsValid(false);

        const initProps = {
            FromDate: _single.getCurrenDate(),
            User: _single.getAccountID(),
            IDAdquisitionContract: row.IDAdquisitionContract,
            ContractValue: row.ContractValue,
            ContractSeleccionDate: row.SeleccionDate,
            IDAccountSupplier: row.IDAccountSupplier,
            IDAdquisitionItem: row.IDAdquisitionItem,
            InternalCode: row.InternalCode,
            IDHiringModality: row.IDHiringModality,
            Nit: row.Nit,
        };

        let processType = "";
        switch (selectedAction) {
            case "STARTSOLOP":
                processType = "STARTSOLOP";
                break;
            case "GCLC":
                processType = "GCLC";
                break;
            default:
                return;
        }

        _bProcess.instance.requestBusinessProcess(
            _single.getAccountID(),
            obs,
            processType,
            "IDAdquisitionContract",
            row.IDAdquisitionContract,
            JSON.stringify(initProps),
            ""
        )
            .then((resp) => {
                toast.success(`Se ha Generado el Proceso ${resp.AlphaCode}`, { autoClose: false });
                modalRequest.close();
            })
            .catch(err => console.log(err));
    };

    return (
        <BasicPage titulo="Mis Contratos">

            <div className="row">
                <div className="col-md-12">
                    <BasicTable head={head} body={lista} rowSet={setRow} listButtons={listaBotones()}
                    //  pageTop={paginador.page}
                    //  next={paginador.next}
                    //  back={paginador.back}
                    //  records={paginador}
                    ></BasicTable>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <Modal modal={modal} updateModal={setModal} >
                        <UBLInvoiceList type={UBLCONTRACT} formData={params} contract={row} importUBL={true} />

                    </Modal>
                    <Modal modal={modalBuscar.modal} updateModal={modalBuscar.setModal} >
                        <div className="row">
                            <div className="col">
                                <UBLInvoiceList type={UBLSUPPLIER} contract={row} formData={
                                    {
                                        IDAccountSupplier: row.IDAccount,
                                        IDAdquisitionContract: row.IDAdquisitionContract,
                                        From: "01-01-" + _single.getCurrenYear() + " 00:00:00",
                                        Upto: _single.getCurrenDate(),
                                        State: null

                                    }
                                } importUBL={false} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalPC} updateModal={setModalPC}>
                        <SupplierPaymentOrder _AdquisitionContrac={row} />
                    </Modal>

                    <Modal modal={modalRP} updateModal={setModalRP}>
                        <AdquisitionContractRP adquisitionContract={row} />
                    </Modal>

                    <Modal modal={modalExpe} updateModal={setModalExpe}>
                        {/* <DodoDoc formCode="127" camp="C0001" value={row.InternalCode} columns={["C0001", "C0002", "C0022", "C0010", "C0017", "C0018", "C0016", "C0019", "C0013", "C0020", "Cod_Barras"]} /> */}
                        {/* <ContractFiles IDAdquisitionContract={row.IDAdquisitionContract} IDAdquisitionItem={row.IDAdquisitionItem} IDHiringModality={row.IDHiringModality} /> */}
                        <EditorExpedientDocumentFile _ClassForName="com.orange.bean.AdquisitionContract" _IDClass={row.IDAdquisitionContract} />
                    </Modal>

                    <Modal onSubmitLabel="Solicitar" modal={modalRequest.modal} updateModal={modalRequest.setModal} eventModal={handleModalSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea
                                    name="obs"
                                    rows={5}
                                    className={`form-control ${isValid ? "is-invalid" : ""}`}
                                    value={obs}
                                    onChange={(e) => setObs(e.target.value)}
                                />
                            </div>
                        </div>
                    </Modal>


                </div>
            </div>

        </BasicPage>
    )
}